import React, { useEffect } from 'react';
import { ReactQueryConfigProvider } from 'react-query';
import { BrowserRouter, HashRouter } from 'react-router-dom';
import reactQueryConfig from './config/reactQueryConfig';
import AppConfiguration from './AppConfiguration';
import SetBrandingStyles from './widget/SetBrandingStyles';
import ScrollToTopOnRouteChange from './util/ScrollToTopOnRouteChange';
import RouteGenerator from './routing/RouteGenerator';
import {LanguageProvider} from './config/TranslationProvider';
import getKlaroConfig from './config/klaro';
import './config/klaroStyleOverride.scss';

const SelectRouter = ({routes, routesWrapper, isWidget}) => {
    const SelectedRouter = isWidget ? HashRouter : BrowserRouter;

    return (
        <SelectedRouter>
            <ScrollToTopOnRouteChange />
            <RouteGenerator routes={routes} routesWrapper={routesWrapper} isWidget={isWidget} />
        </SelectedRouter>
    );
};

const App = ({appConfiguration, routes, isWidget = false, routesWrapper}) => {
    useEffect(() => {
        // Ignore if cookie banner is disabled via the configuration
        if (appConfiguration?.noCookieBanner === true) {
            // Remove consent so the banner shows up again on next visit with an enabled cookie banner
            window.localStorage.removeItem('klaro');

            return;
        }

        // Don't load on the privacy policy or imprint pages
        if (['/privacy', '/imprint'].includes(window.location.pathname)) {
            return;
        }

        // Initialize Klaro cookie consent
        const Klaro = require('klaro');
        // Assign the Klaro module to the window, so that we can access it in JS
        window.klaro = Klaro;
        // Set up Klaro with the config
        Klaro.setup(getKlaroConfig());
    /* eslint-disable-next-line react-hooks/exhaustive-deps */
    },[]);

    return (
        <AppConfiguration config={appConfiguration} isWidget={isWidget}>
            <SetBrandingStyles />
            <ReactQueryConfigProvider config={reactQueryConfig}>
                <LanguageProvider>
                    <SelectRouter routes={routes} routesWrapper={routesWrapper} isWidget={isWidget} />
                </LanguageProvider>
            </ReactQueryConfigProvider>
        </AppConfiguration>
    );
};

export default App;
